// 门户访问埋点：访客ID + 批量上报 + 离开时 sendBeacon
// 数据用于后台"数据面板"的 PV / UV / 来源分析(来源分类在后端完成)
import request from './request'

const STORAGE_KEY = 'mega_visitor_id'

let pending = [] // 待上报的浏览记录
let timer = null
let enabled = true // 由 App.vue 依据系统配置 visit_stat_enabled 设置

export function setVisitTrackingEnabled(val) {
  enabled = val !== false
}

export function isVisitTrackingEnabled() {
  return enabled
}

// 访客ID：localStorage 匿名 UUID(清除即视为新访客)
export function getVisitorId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY)
    if (!id) {
      id = genUuid()
      localStorage.setItem(STORAGE_KEY, id)
    }
    return id
  } catch (e) {
    return genUuid()
  }
}

function genUuid() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

// 外部来源 referrer：同源跳转(整页刷新等)不算外部来源，交由 prevPath 表达
function externalReferrer() {
  try {
    const r = document.referrer
    if (!r) return ''
    const a = new URL(r)
    if (a.host === window.location.host) return ''
    return r
  } catch (e) {
    return ''
  }
}

// 记录一次页面浏览(路由切换时由 App.vue 调用)
export function trackPageView({ pagePath, pageTitle, prevPath }) {
  if (!enabled) return
  if (!pagePath) return
  pending.push({
    visitorId: getVisitorId(),
    pagePath,
    pageTitle: pageTitle || '',
    referrer: externalReferrer(),
    prevPath: prevPath || ''
  })
  scheduleFlush()
}

// 批量上报：最多累积 5 秒或 20 条
function scheduleFlush() {
  if (timer) return
  timer = setTimeout(() => {
    timer = null
    flush()
  }, 5000)
  if (pending.length >= 20) {
    clearTimeout(timer)
    timer = null
    flush()
  }
}

function flush() {
  const items = pending.splice(0, pending.length)
  if (!items.length) return
  request
    .post('/portal/visit', items)
    .catch(() => {
      // 埋点失败静默，不影响浏览体验(放弃这批数据，避免无限重试)
    })
}

// 页面关闭/跳走前把未上报的记录用 sendBeacon 发走(不可靠环境自动丢弃)
export function flushOnUnload() {
  if (!pending.length) return
  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    const items = pending.splice(0, pending.length)
    try {
      const blob = new Blob([JSON.stringify(items)], { type: 'application/json' })
      navigator.sendBeacon('/api/portal/visit', blob)
    } catch (e) {
      pending = items.concat(pending)
    }
  }
}
